import { acceptPSATermsApi } from './acceptPSATermsApi';
import {
  IAcceptPSATermsPayload,
  IAcceptPSATermsResponse,
} from './acceptPSATermsTypes';

const acceptPSATerms = async (
  payload: IAcceptPSATermsPayload
): Promise<IAcceptPSATermsResponse> => {
  const response = await acceptPSATermsApi.acceptPSATerms(payload);

  return response;
};

export const acceptPSATermsService = {
  acceptPSATerms,
};
